// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2VdgX","content":"content___1aSs1","newModel":"newModel___18Swj","header":"header___3my6d","saveButton":"saveButton___iNG7P","errorText":"errorText___163ga","checkBoxContainer":"checkBoxContainer___sgiAE","inputBlick":"inputBlick___CsqLv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CreateMaterial/CreateMaterial.module.css
// module id = 219
// module chunks = 0